import { CheckIcon, CogIcon, DownloadIcon, PlusIcon, SearchIcon, XCircleIcon } from "@heroicons/react/solid";
import hasPermission from "pages/Permissions";
import React, { useEffect, useState } from "react";
import { Button, Nav, Dropdown, Form, InputGroup, OverlayTrigger, Tooltip, Card, Pagination, } from 'react-bootstrap';
import { TbEdit } from "react-icons/tb";
import { Link } from "react-router-dom";
import { Routes } from "routes";
import { useDeleteRouteMappingMutation, useDnldRouteMappingMutation, useListOfRoutesMutation } from "Services/services";
import { downloadBlobFile } from "components/Utility";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import TableWrapper from 'components/TableWrapper';


const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
        customClass: {
            confirmButton: "btn btn-secondary me-3",
            cancelButton: "btn btn-gray",
        },
        buttonsStyling: false,
    })
);

export default () => {
    const [tableData, setTableData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [status, setStatus] = useState("");
    const [pagelimit, setPagelimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalPosts, setTotalPosts] = useState(0);
    const [debouncedValue, setDebouncedValue] = useState("");

    const [templateList] = useListOfRoutesMutation();
    const [deleteUserApi] = useDeleteRouteMappingMutation();
    const [download] = useDnldRouteMappingMutation();

    // Get the id from localStorage
    const userData = localStorage.getItem("TOKEN");
    const userObject = JSON.parse(userData);
    const userType = userObject.user_type;

    useEffect(() => {
        fetchTableData();
        // eslint-disable-next-line
    }, [currentPage, pagelimit, status, debouncedValue]);

    const fetchTableData = () => {
        templateList({
            pageNumber: currentPage,
            limit: pagelimit,
            user_name: searchValue,
        })
            .then((response) => {
                if (response.data?.statusCode === 200) {
                    setTableData(response.data?.data?.finalRouteData || []);
                    setTotalPages(response?.data?.data?.totalPages || 0);
                    setTotalPosts(response?.data?.data?.totalItems || 0);
                } else {
                    setTableData([]);
                    setTotalPages(0);
                    setTotalPosts(0);
                }
            })
            .catch((error) => {
                alert("Error fetching user data in SMS", error);
                setTableData([]);
                setTotalPages(0);
                setTotalPosts(0);
            });
    };

    // Debounce search value
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue); // Set debounced value after 3 seconds
        }, 1000);
        // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    const changeSearchValue = (e) => {
        setSearchValue(e.target.value);
    };

    const deleteRoute = async (props) => {
        const textMessage = "Are you sure you want to delete this Route-Mapping?";
        const result = await SwalWithBootstrapButtons.fire({
            icon: "question",
            title: "Confirm deletion",
            text: textMessage,
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "Cancel"
        });
        if (result.isConfirmed) {
            deleteUserApi({ routeId: props.id, requestedEnterpriseUserId: props.enterprise_user })
                .then(async (response) => {
                    if (response?.data?.statusCode === 200) {
                        const msg = response?.data?.message || "The Route-Mapping has been deleted.";
                        await SwalWithBootstrapButtons.fire(
                            "Deleted",
                            msg,
                            "success"
                        );
                        fetchTableData();
                    } else {
                        const failureMsg = "Failed to Delete.";
                        await SwalWithBootstrapButtons.fire("Failed", failureMsg, "error");
                    }
                })
                .catch(async (error) => {
                    const errMsg = error?.message || "Error deleting this Route-Mapping.";
                    await SwalWithBootstrapButtons.fire("Failed", errMsg, "error");
                });
        }
    };

    const editList = (id) => {
        // const { enterprise_admin: entId } = props;
        // if (!entId) return;
        // setShowEditModal(true);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const canEdit = hasPermission("Routes Mapping", "edit");
    const canDelete = hasPermission("Routes Mapping", "delete");
    const canDownload = hasPermission("Routes Mapping", "download");
    const handleDownload = async () => {
        try {
            const blob = await download({
                user_name: searchValue,
                comm_type: status,
                loggedin_user_id: userObject.id,
                user_type_id: userObject.user_type_id || "1",
            }).unwrap();
            downloadBlobFile(blob, "Routes_Mapping.csv");
        } catch (err) {
            if (err?.status === 404) alert("No data found.");
            else alert("Download failed.");
        }
    };

    const TableRow = (props) => {
        const statusVariant =
            props.channel === "whatsapp"
                ? "success"
                : props.channel === "sms"
                    ? "info"
                    : "warning";

        return (
            <tr className="border-bottom">
                {userType !== "enterprise" && (
                    <td title={props.enterprise_admin_user_name || "-"}>
                        <span className="fw-normal">
                            {props.enterprise_admin_user_name || "-"}
                        </span>
                    </td>
                )}
                {userType !== "enterprise_user" && (
                    <td title={props.enterprise_user_details
                        .map((user) => user.user_name)
                        .join(",") || "-"}>
                        <span className="fw-normal">
                            {props.enterprise_user_details
                                .map((user) => user.user_name)
                                .join(",") || "-"}
                        </span>
                    </td>
                )}
                <td title={props.route_name}>
                    <span className="fw-normal">{props.route_name}</span>
                </td>
                <td title={props.channel}>
                    <span className={`fw-normal text-${statusVariant}`}>
                        {props.channel}
                    </span>
                </td>
                {(canEdit || canDelete) && (
                    <td>
                        {/* {canEdit && (
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip className="m-0">Edit</Tooltip>}
                            >
                                <Card.Link onClick={() => editList(props.id)}>
                                    <TbEdit className="icon icon-xxs text-info" />
                                </Card.Link>
                            </OverlayTrigger>
                        )} */}
                        {canDelete && (
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip className="m-0">Delete</Tooltip>}
                            >
                                <Card.Link
                                    className="ms-2"
                                    onClick={() => deleteRoute(props)}
                                >
                                    <XCircleIcon className="icon icon-xxs text-danger me-2" />
                                </Card.Link>
                            </OverlayTrigger>
                        )}
                    </td>
                )}
            </tr>
        );
    };

    return (
        <Card border={1}>
            <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                {userType !== "enterprise_reporting_user" &&
                    userType !== "enterprise" && (
                        <InputGroup className="fmxw-300 d-flex flex-nowrap">
                            <InputGroup.Text>
                                <SearchIcon className="icon icon-xs" />
                            </InputGroup.Text>
                            <Form.Control
                                type="search"
                                placeholder="Search Enterprise"
                                value={searchValue}
                                onChange={changeSearchValue}
                            />
                        </InputGroup>
                    )}

                <div className="ms-auto d-flex align-items-center gap-2">
                    {canEdit &&
                        <Button
                            variant="secondary"
                            as={Link}
                            to={Routes.CreateMapping.path}
                        >
                            <PlusIcon className="icon icon-xs me-2" />
                            Create Route Mapping
                        </Button>
                    }

                    {canDownload && (
                        <Button
                            variant="outline-gray-300"
                            className="p-2"
                            onClick={handleDownload}
                        >
                            <DownloadIcon className="icon icon-sm" />
                        </Button>
                    )}
                    <Dropdown>
                        <Dropdown.Toggle
                            split
                            as={Button}
                            variant="outline-gray-300"
                            className="text-dark m-0 p-2"
                        >
                            <CogIcon className="icon icon-sm" />
                            <span className="visually-hidden">Toggle Dropdown</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
                            <span className="small ps-2 fw-bold text-dark">Rows per page</span>
                            {[10, 20, 30].map((limit) => (
                                <Dropdown.Item
                                    key={limit}
                                    className={`d-flex align-items-center fw-bold ${limit === 30 ? "rounded-bottom" : ""
                                        }`}
                                    onClick={() => {
                                        setPagelimit(limit); // Update the page limit
                                        setCurrentPage(1); // Reset the page number to 1
                                    }}
                                >
                                    {limit}{" "}
                                    {pagelimit === limit && (
                                        <CheckIcon className="icon icon-xxs ms-auto" />
                                    )}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            <TableWrapper>
                <thead className="thead-light">
                    <tr>
                        {userType !== "enterprise" && (
                            <th className="border-bottom">Enterprise</th>
                        )}
                        {userType !== "enterprise_user" && (
                            <th className="border-bottom">Enterprise User</th>
                        )}
                        <th className="border-bottom">Route</th>
                        <th className="border-bottom">Channel</th>
                        {(canEdit || canDelete) && (
                            <th className="border-bottom">Actions</th>
                        )}
                    </tr>
                </thead>
                <tbody className="border-0">
                    {tableData.length > 0 ? (
                        tableData.map((u, index) => <TableRow key={index} {...u} />)
                    ) : (
                        <tr>
                            <td colSpan="5" className="text-center text-danger">
                                No Data Found
                            </td>
                        </tr>
                    )}
                </tbody>
            </TableWrapper>

            <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
                <Nav>
                    <Pagination className="mb-0">
                        <Pagination.Prev
                            onClick={handlePrev}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </Pagination.Prev>
                        {currentPage >= 3 && (
                            <>
                                <Pagination.Item onClick={() => handlePageChange(1)}>
                                    1
                                </Pagination.Item>
                                <Pagination.Ellipsis />
                            </>
                        )}
                        {currentPage > 1 && (
                            <Pagination.Item
                                onClick={() => handlePageChange(currentPage - 1)}
                            >
                                {currentPage - 1}
                            </Pagination.Item>
                        )}
                        <Pagination.Item active>{currentPage}</Pagination.Item>
                        {currentPage < totalPages && (
                            <Pagination.Item
                                onClick={() => handlePageChange(currentPage + 1)}
                            >
                                {currentPage + 1}
                            </Pagination.Item>
                        )}
                        {currentPage < totalPages - 1 && (
                            <>
                                <Pagination.Ellipsis />
                                <Pagination.Item
                                    onClick={() => handlePageChange(totalPages)}
                                >
                                    {totalPages}
                                </Pagination.Item>
                            </>
                        )}
                        <Pagination.Next
                            onClick={handleNext}
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </Pagination.Next>
                    </Pagination>
                </Nav>
                <small className="fw-normal small mt-2 mt-md-0">
                    Showing{" "}
                    <b>
                        {totalPosts == 0
                            ? totalPosts
                            : pagelimit * (currentPage - 1) + 1}
                        -
                        {pagelimit * currentPage > totalPosts
                            ? totalPosts
                            : pagelimit * currentPage}
                    </b>{" "}
                    of <b>{totalPosts}</b> entries.
                </small>
            </Card.Footer>
        </Card>

    );
};
